import view from "../views";

const pagesRoutes = [
  { component: view.Monitor, path: "/home", exact: true, name: "Home" },
  { component: view.Country, path: "/country", exact: true, name: "country" },
  { component: view.CollectingEntity, path: "/collect_entity", exact: true, name: "CollectingEntity" },
  { component: view.ChannelTransaction, path: "/channel_transaction", exact: true, name: "ChannelTransaction" },
  { component: view.TypeConcept, path: "/type", exact: true, name: "TypeConcept" },
  { component: view.Branch, path: "/branch", exact: true, name: "Branch" },
  { component: view.Channel, path: "/channel", exact: true, name: "Channel" },
  { component: view.Account, path: "/account", exact: true, name: "Account" },
  { component: view.LimitAmountEntity, path: "/limitAmountEntity", exact: true, name: "LimitAmountEntity" },
  { component: view.ChannelEntityPayment, path: "/channelEntityPayment", exact: true, name: "ChannelEntityPayment" },
  { component: view.Message, path: "/message", exact: true, name: "Message" },
  { component: view.Monitor, path: "/monitor", exact: true, name: "Monitor" },
  { component: view.SendIncome, path: "/send_payment", exact: true, name: "SendIncome" },
  { component: view.ClientSap, path: "/clientSap", exact: true, name: "ClientSap" },
  { component: view.ConciliationMonitor, path: "/conciliation_monitor", exact: true, name: "ConciliationMonitor" },
  { component: view.Summary, path: "/conciliation", exact: true, name: "Summary" },
  { component: view.ConnectionSftp, path: "/connectionsftp", exact: true, name: "ConnectionSftp" },
  { component: view.Template, path: "/template", exact: true, name: "Template" },
  { component: view.TemplateAssign, path: "/assign_template", exact: true, name: "TemplateAssign" },
  { component: view.History, path: "/history", exact: true, name: "History" }
];
export default pagesRoutes;
